export enum InstallStatus {
  CHECKING,
  INSTALLING,
  INSTALLED,
  NOT_SUPPORTED,
  ERROR,
}
